import { ColorPicker, InputNumber, Select, Slider, Switch } from 'antd';
import { useLayerProperitesContext } from '../../../context/LayerPropertiesContext';
import './LayerProperties.scss';

const disableAtOptions = [
  { label: '6', value: 6 },
  { label: '8', value: 8 },
  { label: '10', value: 10 },
  { label: '12', value: 12 },
  { label: '14', value: 14 },
  { label: '16', value: 16 },
  { label: '18', value: 18 },
];

const EffectsTab = () => {
  const {
    clustering,
    spiralOnHover,
    disableAt,
    clusterRadius,
    clusterColor,
    glow,
    glowColor,
    glowStrength,
    glowRadius,
    greyScale,
    setState,
    layerTitle,
  } = useLayerProperitesContext();

  return (
    <>
      <h3 className="lp-tab__title--no-margin">{layerTitle}</h3>
      <div className="lp-controls__row">
        <span className="lp-controls__label">CLUSTERING</span>
        <Switch checked={clustering} onChange={(checked) => setState((prev) => ({ ...prev, clustering: checked }))} />
      </div>
      <div className="lp-controls__row">
        <span className="lp-controls__label">SPIRAL ON HOVER</span>
        <Switch checked={spiralOnHover} onChange={(checked) => setState((prev) => ({ ...prev, spiralOnHover: checked }))} />
      </div>
      <div className="lp-controls__row--no-margin">
        <span className="lp-controls__label--fixed">DISABLE AT</span>
        <Select
          className="lp-controls__flex"
          placeholder="Select One"
          value={disableAt}
          onChange={(value) => setState((prev) => ({ ...prev, disableAt: value }))}
          options={disableAtOptions}
        />
      </div>
      <div className="lp-controls__row--mt">
        <span className="lp-controls__label--fixed">CLUSTER RADIUS</span>
        <Slider value={clusterRadius} onChange={(value) => setState((prev) => ({ ...prev, clusterRadius: value }))} className="lp-controls__flex" />
        <InputNumber
          className="lp-controls__input"
          value={clusterRadius}
          onChange={(e) => setState((prev) => ({ ...prev, clusterRadius: Number(e) || 1 }))}
          min={0}
          max={100}
          placeholder="px"
        />
      </div>
      <div className="lp-controls__row--no-margin">
        <span className="lp-controls__label--fixed">CLUSTER COLOR</span>
        <ColorPicker
          className="custom-button"
          value={clusterColor}
          onChange={(value) => setState((prev) => ({ ...prev, clusterColor: value.toHexString() }))}
          showText
        />
      </div>
      <div className="lp-controls__row--mt">
        <span className="lp-controls__label">GLOW</span>
        <Switch checked={glow} onChange={(checked) => setState((prev) => ({ ...prev, glow: checked }))} />
      </div>
      <div className="lp-controls__row--no-margin">
        <span className="lp-controls__label--fixed">GLOW COLOR</span>
        <ColorPicker
          className="custom-button"
          value={glowColor}
          onChange={(value) => setState((prev) => ({ ...prev, glowColor: value.toHexString() }))}
          showText
        />
      </div>
      <div className="lp-controls__row--mt">
        <span className="lp-controls__label--fixed">GLOW STRENGTH</span>
        <Slider
          min={1}
          max={10}
          value={glowStrength}
          onChange={(value) => setState((prev) => ({ ...prev, glowStrength: value }))}
          className="lp-controls__flex"
        />
        <InputNumber
          className="lp-controls__input"
          value={glowStrength}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              glowStrength: Math.min(10, Math.max(1, Number(e))),
            }))
          }
          min={0}
          max={100}
          placeholder="1-10"
        />
      </div>
      <div className="lp-controls__row--mt">
        <span className="lp-controls__label--fixed">GLOW RADIUS</span>
        <Slider value={glowRadius} onChange={(value) => setState((prev) => ({ ...prev, glowRadius: value }))} className="lp-controls__flex" />
        <InputNumber
          className="lp-controls__input"
          value={glowRadius}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              glowRadius: Number(e),
            }))
          }
          min={0}
          max={100}
          placeholder="px"
        />
      </div>
      <div className="lp-controls__row--mt">
        <span className="lp-controls__label">GREYSCALE</span>
        <Switch checked={greyScale} onChange={(checked) => setState((prev) => ({ ...prev, greyScale: checked }))} />
      </div>
    </>
  );
};

export default EffectsTab;
